export const radii = {
  s: "1px",
  xs: "2px",
  sm: "4px",
  md: "6px",
  lg: "8px",
}
